<template>
  <div v-show="showAddAndEdit" class="active_sessions">
    <div class="divider-line"></div>
    <!-- <div class="acctive-sessions-header" style="display:inline">可选场次：</div> -->
    <div style="display:inline">
      <el-tag
        :key="tag"
        v-for="tag in dynamicTags"
        closable
        type="info"
        :disable-transitions="false"
        @close="handleClose(tag)"
      >场次：{{tag}}</el-tag>
      <el-input
        size="mini"
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      ></el-input>

      <el-button size="mini" v-else class="button-new-tag" @click="showInput">+ 添加场次</el-button>
      <span
        v-if="haveTags"
        @click="cancleAddTag"
        class="show-cancle-add"
        style="float:right;cursor: pointer;color:lightgray"
      >取消添加</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "add-and-edit-tag",
  data() {
    return {
      haveTags: false,
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      showAddAndEdit: this.showAddAndEditTag,
    };
  },
  props: {
    // css绑定
    attribuite: Number,
    sku_more_info: String,
    showAddAndEditTag: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    let more_info_type = this.sku_more_info;
    let more_info_dict = new Function("return " + more_info_type)();
    if (more_info_dict) {
      if (more_info_dict.key == "round") {
        this.showAddAndEdit = true;
        this.dynamicTags = more_info_dict.round;
      }
    }
  },
  methods: {
    cancleAddTag() {
      if (this.dynamicTags.length == 0) {
        this.haveTags = false;
        this.showAddAndEdit = false;
      } else {
        this.haveTags = false;
      }
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      let round = {
        sku_id: this.attribuite,
        round: this.dynamicTags,
      };

      this.$http.post("/product/add_sku_more_info/round", round).then((res) => {
        console.log(res);
      });
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      // 遍历以下，看看有没有一样的，如果有一样的得阻止

      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        let round = {
          sku_id: this.attribuite,
          round: this.dynamicTags,
        };

        this.$http
          .post("/product/add_sku_more_info/round", round)
          .then((res) => {
            console.log(res);
          });
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style>
.active_sessions_none {
  display: none;
  margin-bottom: 10px;
  padding: 0px 10px;
  /* background-color: tomato; */
  border-radius: 3px;
}
.active_sessions {
  /* margin-bottom: 10px; */
  padding: 0px 10px;
  /* background-color: tomato; */
  border-radius: 3px;
}
.active_sessions:hover .show-cancle-add {
  display: inline;
}
.show-cancle-add {
  display: none;
}
.acctive-sessions-header {
  font-size: large;
  color: white;
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.divider-line {
  height: 10px;
  margin-top: 10px;
  border-top-style: solid;
  border-color: lightgray;
}
</style>